import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "counter-container relative w-[100px]",
  id: "inputCounter"
}

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuantityCounter',
  setup(__props) {

const internalValue = ref<number>(1);

const increment = () => {
  internalValue.value++;
};

const decrement = () => {
  if (internalValue.value > 0) {
    internalValue.value--;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "decrease-btn top-1/2 -translate-y-1/2 absolute text-[20px] ltr:left-[15px] rtl:right-[15px] text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500",
      onClick: decrement
    }, " - "),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      class: "counter text-[15px] h-[42px] rounded-md text-center block w-full bg-[#f6f7f9] dark:bg-[#15203c] text-black outline-0 font-medium dark:text-white",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
      readonly: ""
    }, null, 512), [
      [_vModelText, internalValue.value]
    ]),
    _createElementVNode("button", {
      class: "increase-btn top-1/2 -translate-y-1/2 absolute text-[20px] ltr:right-[15px] rtl:left-[15px] text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500",
      onClick: increment
    }, " + ")
  ]))
}
}

})